import {EDIT_PROJECT_STARTED} from "../../../reducers/settingsReducer";


export const editProjectStarted = () =>{
    return {
        type: EDIT_PROJECT_STARTED,
        payload: {}
    }
}